import React, { useState } from 'react';
import styles from './EditSecurityModal.module.css';
import axios from 'axios';
import { BASE_URL } from '../../Components/Api/Api';
import Swal from "sweetalert2";

const EditSecurityModal = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Clear error message when user updates passwords
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  if (formData.newPassword !== formData.confirmPassword) {
  Swal.fire({
    icon: "error",
    title: "Passwords Do Not Match",
    text: "New password and confirmation password must be the same.",
    confirmButtonColor: "#d33",
  });
  return;
}

if (formData.newPassword.length < 6) {
  Swal.fire({
    icon: "warning",
    title: "Password Too Short",
    text: "New password must be at least 6 characters long.",
    confirmButtonColor: "#f59e0b",
  });
  return;
}

  // if (formData.newPassword !== formData.confirmPassword) {
  //   setError("New passwords do not match!");
  //   return;
  // }

  // if (formData.newPassword.length < 6) {
  //   setError("New password must be at least 6 characters long.");
  //   return;
  // }

  setError("");
  setIsSubmitting(true);

  try {
    const token = localStorage.getItem("token"); // Adjust if your token is stored elsewhere
    const companyid = localStorage.getItem("companyId");
    const memberid = localStorage.getItem("memberId")

    const response = await axios.post(
       `${BASE_URL}/member-auth/change_member_password`,
      {
        current_password: formData.currentPassword,
        new_password: formData.newPassword,
        new_password_confirmation: formData.confirmPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data.message || "Password changed successfully.",
      confirmButtonColor: "#3085d6",
    });

    setFormData({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

    onClose();
  } 
  catch (err) {
  console.error(err);

  let errorMessage = "Unable to change password. Please try again.";

  if (err.response?.data?.message) {
    const message = err.response.data.message;

    // If the API returns validation errors as an object
    if (typeof message === "object") {
      errorMessage = Object.values(message)
        .flat()
        .join("\n");
    } else {
      errorMessage = message;
    }
  } else if (err.response?.data?.error) {
    errorMessage = err.response.data.error;
  }

  Swal.fire({
    icon: "error",
    title: "Failed",
    text: errorMessage,
    confirmButtonColor: "#d33",
  });

  // Only set strings into React state
  setError(errorMessage);
}
  finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Update Security Password</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          {error && <div className={styles.errorMessage}>{error}</div>}

          <div className={styles.formColumn}>
            {/* Current Password */}
            <div className={styles.formGroup}>
              <label htmlFor="currentPassword">Current Password <span className={styles.required}>*</span></label>
              <input 
                type="password" 
                id="currentPassword"
                name="currentPassword" 
                value={formData.currentPassword} 
                onChange={handleChange} 
                required 
              />
            </div>

            {/* New Password */}
            <div className={styles.formGroup}>
              <label htmlFor="newPassword">New Password <span className={styles.required}>*</span></label>
              <input 
                type="password" 
                id="newPassword"
                name="newPassword" 
                value={formData.newPassword} 
                onChange={handleChange} 
                required 
              />
            </div>

            {/* Confirm New Password */}
            <div className={styles.formGroup}>
              <label htmlFor="confirmPassword">Confirm New Password <span className={styles.required}>*</span></label>
              <input 
                type="password" 
                id="confirmPassword"
                name="confirmPassword" 
                value={formData.confirmPassword} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>

          <div className={styles.formActions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={isSubmitting}>Cancel</button>
            <button type="submit" className={styles.saveBtn} disabled={isSubmitting}>
              {isSubmitting ? 'Updating...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSecurityModal;